angular.module('rightPaneModule')
  .controller('SchoolTeachersController', [
      '$scope',
      '$state',
      'edxReportItemService',
      'teacherApi',
      'timeframe',
      'tableColumns',
      'tableSort',
      'authentication',
      'edxTimeframeListService',
      'reportErrors',
      'schoolApi',
      function (
          $scope,
          $state,
          edxReportItemService,
          $teacherApi,
          timeframe,
          $tableColumns,
          $tableSort,
          dblAuthentication,
          edxTimeframeListService,
          $reportErrors,
          schoolApi) {
      // Set to true once we've subscribed to our Angular event to avoid subscribing twice
      var areEventsSubscribed = false;

      $scope.listTableData = [];

      var updateMode = function() {
          $scope.listTableColumns = $tableColumns.getColumns('teacher_fractions');

          var defaultColumn = $tableSort.getDefaultColumn($scope.listTableColumns);
          $scope.activeMetric = $state.params.sort || defaultColumn || $scope.listTableColumns[0];
      };

      updateMode();

      $scope.defaultMetric = 'percent_growth';

      $scope.years = {list: null, selected: {}};

      var timeframeIds = ['7d', '30d'];
      var defaultTimeframeId = '30d';
      $scope.timeframes = edxTimeframeListService.buildTimeframes(timeframeIds, defaultTimeframeId);

      var updateTeachers = function () {
          $scope.teachersReportingUrl = $teacherApi.getTeachersReportingExportUrl();
          $scope.tableError = null;
          $scope.listTableData = undefined;
          $teacherApi.getTeachersReporting().then(function (data) {
              $scope.listTableData = $tableSort.sortColumn($scope.listTableColumns, data);
          }, function(error) {
              $scope.listTableData = undefined;
              $scope.tableError = $reportErrors.getErrorMessage(error);
          });
      };

      var updateTableSort = function () {
          $scope.listTableData = $tableSort.sortColumn($scope.listTableColumns, $scope.listTableData);
      };

      var updateFrequencyData = function () {
          $scope.frequencyError = null;
          $scope.frequencyData = undefined;
          $teacherApi.getTeachersFrequency().then(function (data) {
              $scope.frequencyData = data;
          }, function(error) {
              $scope.frequencyError = $reportErrors.getErrorMessage(error);
          });
      };

      var updateTeachersPaging = function (e, page) {
          $state.current.data.page = page;
          $scope.listTableData = undefined;
          $teacherApi.getTeachersReporting().then(function (data) {
              var uniqueList = _.uniq($scope.listTableData.concat(data), false, function (li) {
                  return li.id;
              });
              $scope.listTableData = uniqueList;
          });
      };

      var updateHighlights = function () {
          var params = _.pick($state.params, ['districtId']);
          params.school_id = $state.params.schoolId;
          params.grade_id = $state.params.gradeId || undefined;
          params = _.extend(params, timeframe.getTimeframeParams());
          $scope.schoolData = undefined;

          schoolApi.getSchoolHighlights(params).then(function (schoolData) {
              $scope.schoolData = schoolData;
          });
      };

      var updateData = function () {
          updateMode();

          if (!$state.params.timeframe) {
              timeframe.updateStateParams($scope.timeframes.selected.id)
                .then(function () {
                    updateTeachers();
                    updateFrequencyData();
                    updateHighlights();
                });
          } else {
              updateTeachers();
              updateFrequencyData();
              updateHighlights();
          }
      };

      var initializeData = function (item) {
          // Note that initially $scope.item === item because item is set on a parent scope!!
          // Once we set $scope.item = item then we have our own item reference which can be different from the parent
          if (!_.eq($scope.item, item) || !areEventsSubscribed) {
              $scope.item = item;
              updateData();
          }

          // We never want to subscribe to events multiple times or else we will receive each event multiple times
          if (!areEventsSubscribed) {
              $scope.$on('updateSortableTable', updateTableSort);

              $scope.$on('listTableRowClicked', function (e, item) {
                $scope.$emit('route', item);
              });

              $scope.$on('yearSelected', updateData);

              $scope.$on('timeframeSelected', updateData);

              $scope.$on('listTableNextPage', updateTeachersPaging);

              areEventsSubscribed = true;
          }
      };

      var itemSubscription = edxReportItemService.getCurrentItemObservable().subscribe(function (item) {
          initializeData(item);
      });

      var timeframeSubscription = timeframe.getYearListSubject().subscribe(function (years) {
          $scope.years.list = angular.copy(years);
      });

      $scope.$on('$destroy', function () {
          itemSubscription.dispose();
          timeframeSubscription.dispose();
      });
  }]);
